module.exports = __webpack_public_path__ + "f5c0b106fcf0668ccbaaef0b5261d65d.svg";